import { useEffect, useRef } from 'react'

import { Icon } from './Icon'
import styles from './Lightbox.module.css'
import { useScrollLock } from './useScrollLock'

export interface LightboxProps {
  open: boolean
  image: string
  alt: string
  title: string
  description: string
  source?: string
  onClose: () => void
  inline?: boolean
}

export function Lightbox({ open, image, alt, title, description, source = 'Meta 广告资料库', onClose, inline = false }: LightboxProps) {
  const boxRef = useRef<HTMLDivElement>(null)
  useScrollLock(open && !inline)

  useEffect(() => {
    if (!open) return
    boxRef.current?.focus()
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', closeOnEscape)
    return () => window.removeEventListener('keydown', closeOnEscape)
  }, [onClose, open])

  if (!open) return null
  return (
    <div className={`${styles.scrim} ${inline ? styles.inline : styles.animated}`} onMouseDown={(event) => { if (event.target === event.currentTarget) onClose() }}>
      <div ref={boxRef} className={`${styles.lightbox} ${inline ? '' : styles.interactive}`} role="dialog" aria-modal={!inline} tabIndex={-1}>
        {inline ? null : <button type="button" className={styles.close} aria-label="关闭灯箱" onClick={onClose}><Icon name="x" /></button>}
        <img className={styles.image} src={image} alt={alt} />
        <div className={styles.caption}>
          <b className={styles.title}>{title}</b>
          <p className={styles.description}>{description}</p>
          <p className={styles.source}>来源：{source}</p>
        </div>
      </div>
    </div>
  )
}
